export const HOMETRACK_ADDON_ROUTE = "/general/hometrack";
export const LANDFUND_ADDON_ROUTE = "/other/landfund";
export const GIVE_MY_VIEW_ADDON_ROUTE = "/other/give-my-view";
